<script lang="ts">
  import { Col, Container, Row } from "sveltestrap";
  import BookmarkCreateNew from "./BookmarkCreateNew.svelte";
  import Card from "../../../Core/Card.svelte";
  import Formdata from "./Formdata.svelte";
</script>

<BookmarkCreateNew />
<Container fluid>
  <Row>
    <Col sm="12">
      <Card>
        <div slot="contentbody">
          <Formdata />
        </div>
      </Card>
    </Col>
  </Row>
</Container>
